import { render, staticRenderFns } from "./Baogia.vue?vue&type=template&id=af52b180&"
import script from "./Baogia.vue?vue&type=script&lang=js&"
export * from "./Baogia.vue?vue&type=script&lang=js&"
import style0 from "./Baogia.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports